export const state = {
  user: null,
  error: null,
  loading: false,
  loadingDescript: ''
}